import React from 'react';
import Tag from './Tag';


const EventStatus = (props) => {
  return (
    <div>
      <Tag show={props.data.registrationEnabled} title='Open' color='green' />
      <Tag show={!props.data.registrationEnabled} title='Closed' color='grey' />
      <Tag show={!props.data.published} title='Not Published' color='red' />
      <Tag show={props.data.test} title='Test' color='grey' />
    </div>
  );
};

export default EventStatus;



// WEBPACK FOOTER //
// ./src/private/admin/components/EventStatus/index.js